import { Directive, ElementRef, HostListener, Inject } from "@angular/core";
import { NgControl } from "@angular/forms";


@Directive({
    selector: '[custom-currency]'
})
export class CustomCurrencyDirective {

    constructor(@Inject(NgControl) private control, @Inject(ElementRef) private el: ElementRef) {}

    @HostListener('input', ['$event']) onInputChange(event) {
        const initialValue = this.el.nativeElement.value;
        const reformattedValue = this.formatToCurrency(initialValue)
        if (initialValue !== reformattedValue) {
            this.el.nativeElement.value = reformattedValue;
            this.control.viewToModelUpdate(reformattedValue);
        }
    }

    formatToCurrency(text: string): string {

        let tempSplit;

        if (text) {
            // only allow digits and decimals
            let transformedInput = text.replace(/[^0-9.]/g, '');

            // no consecutive decimals
            transformedInput = transformedInput.replace(/\.\./g, '.')

            // and only allow one decimal
            tempSplit = transformedInput.split('.');
            if (tempSplit.length > 2) {
                transformedInput = tempSplit[0] + "." + tempSplit[1]
            }

            // only allow 2 digits after the decimal
            tempSplit = transformedInput.split('.');
            if (tempSplit[1] && tempSplit[1].length > 2) {
                transformedInput = tempSplit[0] + '.' + tempSplit[1].slice(0, 2);
            }

            return transformedInput;
        }
        return text;
    }

}
